import ContentCard from '../components/ContentCard';
import PageShell from '../components/PageShell';
import useSiteContent from '../hooks/useSiteContent';
import { fallbackLinks } from '../data/fallbackContent';

export default function Archived() {
  const { data: links } = useSiteContent('links', fallbackLinks);
  const archived = links.filter(
    (item) => String(item.archived).toUpperCase() === 'TRUE'
  );

  return (
    <PageShell>
      <section className="page-heading text-heading">
        <div>
          <p className="eyebrow">Past links</p>
          <h1>The archive</h1>
          <p>Previously featured tools, releases, and discoveries.</p>
        </div>
      </section>

      <section className="link-stack" aria-label="Archived links">
        {archived.length ? archived.map((item, index) => (
          <ContentCard
            key={item.id}
            item={item}
            entity="links"
            index={index}
          />
        )) : (
          <div className="empty-state">The archive is quiet for now.</div>
        )}
      </section>
    </PageShell>
  );
}